import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import MenuDrawer from '../MenuDrawer';
import FarmLogo from '../../../assets/logo_farmRio.svg';

export default function Header({ onClose }) {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      style={{ marginBottom: 16 }}
    >
      <MenuDrawer />
      <img style={{ width: 250 }} src={FarmLogo} alt="Farm Rio" />
      <Grid
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Typography
          onClick={onClose}
          style={{ fontSize: 12, cursor: 'pointer', marginRight: 50 }}
        >
          Close X
        </Typography>
      </Grid>
    </Grid>
  );
}
